<div
  *ngIf="relationsCards$ | async as relationsCards"
  class="card-relation-manager">
  <div class="card-actions">
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      type="button"
      mat-raised-button
      (click)="addRelationHandler()">
      {{ 'Aggiungi relazione' | translate }}
    </button>
  </div>

  <div [formGroup]="form">
    <ui-draggable-list
      *ngIf="relationsCards.length > 0; else noItems"
      [items]="relationsCards"
      [sortingDisabled]="true">
      <ng-template
        uiListItem
        let-relation="item"
        let-i="index">
        <div class="card-container">
          <div class="card-actions">
            <button
              *roleVisibility="['create', 'update']; classNames: classNames"
              mat-icon-button
              type="button"
              (click)="removeRelationHandler(relation, i)">
              <mat-icon>delete</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              [routerLink]="['/cards/s/manager', relation?.beneOA]">
              <mat-icon>details</mat-icon>
            </button>
          </div>
          <div
            class="card-info-container"
            [formArrayName]="i">
            <img
              *ngIf="relation?.bene?.previewUrl"
              class="card-preview-img"
              loading="lazy"
              [src]="relation?.bene?.previewUrl">
            <div class="card-info-details">
              <mat-form-field class="card-info">
                <textarea
                  matInput
                  formControlName="descrizione"
                  [placeholder]="'Descrizione' | translate"></textarea>
              </mat-form-field>
              <mat-form-field class="card-info">
                <input
                  matInput
                  formControlName="tipo"
                  [placeholder]="'Tipo' | translate">
              </mat-form-field>
              <small class="card-info">
                {{ 'Titolo' | translate }}: {{ relation?.bene.SGT.SGTT  }}
              </small>
              <small class="card-info">
                {{ 'Codice Unico' | translate }}: {{ relation?.bene.codiceUnico }}
              </small>
            </div>
          </div>
        </div>
      </ng-template>
    </ui-draggable-list>

    <ng-template #noItems>
      <ui-no-items></ui-no-items>
    </ng-template>
  </div>
</div>
